import Vue from 'vue'
import VueRouter from 'vue-router'
import EmbedMap from '../views/EmbedMap.vue'

// Import styles if needed
import '../assets/css/index.css'

Vue.use(VueRouter)

document.addEventListener('DOMContentLoaded', () => {
  const configEl = document.getElementById('embed-config')
  const disclaimerText = configEl ? configEl.dataset.disclaimer : ''
  // Raw, unparsed: EmbedMap owns the parsing so the iframe and the
  // <artaround-map> element agree on what `labels="off"` means.
  const labels = configEl ? configEl.dataset.labels || '' : ''

  const app = new Vue({
    render: h => h(EmbedMap, { props: { disclaimerText, labels } }),
    router: new VueRouter({ mode: 'history' }), // Dummy router for MapComponent
  }).$mount()
  app.$el.classList.add('w-screen', 'h-screen')
  document.body.appendChild(app.$el)
})
